import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Card } from '@uhg-abyss/web/ui/Card';
import { useLagoon } from '@src/app/tools/lagoon';
import { SubmitterName } from './Inputs/SubmitterName';
import { EmailAddress } from './Inputs/EmailAddress';
import { JobTitle } from './Inputs/JobTitle/JobTitle';
import { PhoneNumber } from './Inputs/PhoneNumber/PhoneNumber';
import { CommunicationPreference } from './Inputs/CommunicationPreference';
import { SubmittedClaim } from './Inputs/SubmittedClaim';
import { ClaimCalender } from './Inputs/ClaimCalender';
import { HealthPlanCoverage } from './Inputs/HealthPlanCoverage';

const AlignInput = styled('div', {
  width: '70%',
  marginBottom: '4%',
});

const CheckboxStyle = styled('div', {
  padding: '8px 0px',
  margin: '8px 10px 8px 0px',
});

export const Attestation = () => {
  const form = useForm();

  const { featureToggles } = useLagoon();
  const attestationData = form.getValues('attestation');

  return (
    <Card header="Attestation">
      <Card.Section>
        <Text fontWeight="bold" id="attestation-text">
          By signing this Provider Registration Form, I understand and agree to
          the following:
        </Text>
        <FormProvider state={form}>
          <CheckboxStyle>
            <Checkbox
              id="attestation-checkbox-1"
              model="attestation.providerAttestCheckbox1"
              validators={{ required: 'Must check box before submitting.' }}
              label="I attest that I am submitting as an individual and am the
                    sole healthcare professional associated with this billing
                    TIN OR I am submitting on behalf of my group/facility and I
                    am authorized to submit registration information for this
                    billing TIN."
            />
          </CheckboxStyle>
          <CheckboxStyle>
            <Checkbox
              id="attestation-checkbox-2"
              model="attestation.providerAttestCheckbox2"
              validators={{ required: 'Must check box before submitting.' }}
              label="I agree to notify UnitedHealthcare in writing of any
                change in the information in this form within 10 days of
                that change."
            />
          </CheckboxStyle>
          <CheckboxStyle>
            <Checkbox
              id="attestation-checkbox-3"
              model="attestation.providerAttestCheckbox3"
              validators={{ required: 'Must check box before submitting.' }}
              label="I agree that the primary servicing address listed for the
                company is not a P.O. Box or a residential home but a
                building zoned for a business."
            />
          </CheckboxStyle>
          <CheckboxStyle>
            <Checkbox
              id="attestation-checkbox-4"
              model="attestation.providerAttestCheckbox4"
              validators={{ required: 'Must check box before submitting.' }}
              label="I will not knowingly present or cause to be presented any
                false or fraudulent claim for payment, and I will not
                submit claims with deliberate ignorance or reckless
                disregard of their truth or falsity."
            />
          </CheckboxStyle>
          <CheckboxStyle>
            <Checkbox
              id="attestation-checkbox-5"
              model="attestation.providerAttestCheckbox5"
              validators={{ required: 'Must check box before submitting.' }}
              label="None of the owners, practitioners, providers or employees
                that are employed by a provider is currently sanctioned,
                suspended, debarred, or excluded from participation in
                Medicare, Medicaid or a federal health care program."
            />
          </CheckboxStyle>
          <CheckboxStyle>
            <Checkbox
              id="attestation-checkbox-6"
              model="attestation.providerAttestCheckbox6"
              validators={{ required: 'Must check box before submitting.' }}
              label={
                <Text fontWeight="bold">
                  I certify, represent and warrant that all information provided
                  on this registration form is true, accurate and complete and
                  that I am authorized to act on behalf of the provider.
                </Text>
              }
            />
          </CheckboxStyle>
          <Grid id="attest-inputs">
            <Grid.Col span="33%">
              <AlignInput>
                <SubmitterName />
              </AlignInput>
            </Grid.Col>
            <Grid.Col span="33%">
              <AlignInput>
                <EmailAddress />
              </AlignInput>
            </Grid.Col>
            <Grid.Col span="33%">
              <AlignInput>
                <SubmittedClaim />
              </AlignInput>
            </Grid.Col>
            <Grid.Col span="33%">
              <AlignInput>
                <JobTitle />
              </AlignInput>
            </Grid.Col>
            <Grid.Col span="33%">
              <AlignInput>
                <PhoneNumber />
              </AlignInput>
              <CommunicationPreference />
            </Grid.Col>
            <Grid.Col span="33%">
              <AlignInput>
                {attestationData?.submitClaim === 'Yes' && <ClaimCalender />}
              </AlignInput>
              {featureToggles('US5661375_AARP') && <HealthPlanCoverage />}
              <AlignInput />
            </Grid.Col>
          </Grid>
        </FormProvider>
      </Card.Section>
    </Card>
  );
};
